import PlayerRemoteBase from "./PlayerRemoteBase";

class PlayerSync {

    constructor(args = {}) {
        this.args = args;
    }

    get Instance() {

        let _getImg, _setImg, _setSliderPos, _direction, _setShowSlider, _args = this.args


        const PlayerSync = class PS extends PlayerRemoteBase {

            constructor() {
                super();
                this.notifySliderPos = _args.notifySliderPos;
                this.notifyImgNumber = _args.notifyImgNumber;
                this.notifyImgLoaded = _args.notifyImgLoaded;
            }
            
            sync(o) {
                super.sync(o)
                _direction = _direction || o.direction
                _setImg = _setImg || o.setImg;
                _getImg = _getImg || o.getImg;
                _setSliderPos = _setSliderPos || o.setSliderPos;
                _setShowSlider = _setShowSlider || o.setShowSlider;
            }

            set direction(direction) {
                _direction?.(direction)
            }

            get direction() {
                return _direction?.()
            }

            set img(realPos) {
                _setImg({ realPos })
                this.notifyImgNumber?.(realPos);
            }

            get img() {
                return _getImg()
            }
            
            setImgAsync(img) {
                return _setImg({ realPos: img }).then(() => {
                    this.notifyImgNumber?.(img);
                })
            }

            set slider(val) {
                if (typeof val === 'number') {
                    _setSliderPos(val);
                    this.notifySliderPos?.(val)
                }
                else {
                    _setShowSlider(!!val);
                }
            }

        }

        return new PlayerSync;
    }
}

export default PlayerSync;